import { post, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR  from 'swr'
import { handleApiResponse } from './api_util';

async function deleteUser(userData){
  const userID=userData.userID
  const payload={
    apiName: 'LivisiblyAdminUserApi',
    path: `users/${userID}`,
    // options: {
    //   body: {
    //     user_data: userData,
    //   }
    // }
  }
  const restOperation = del(payload);
  const response = await restOperation.response;
  return processResponse(response)

}



async function getUsers(){

  const payload={
    apiName: 'LivisiblyAdminUserApi',
    path: 'users'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}

export function useGetUsers(shouldFetch=true){
  const result = useSWR(
    shouldFetch ? 'USERS' : null,
    (path) => getUsers()
  );
  return result;
}


async function getUser(userID){
  const payload={
    apiName: 'LivisiblyAdminUserApi',
    path: `users/${userID}`
  }

  const restOperation = get(payload);


  const response = await restOperation.response;
  return processResponse(response)
}

export function useGetUser(userID, shouldFetch=true){
  const result = useSWR(
    shouldFetch ? ['USERS', userID] : null,
    ([path, userID]) => getUser(userID)
  );
  return result;
}

async function createUser(userData){
    const payload={
        apiName: 'LivisiblyAdminUserApi',
        path: 'users',
        options: {
          body: {
            user_data: userData,
          }
        }
      }

      const restOperation = post(payload);


      const response = await restOperation.response;
      return processResponse(response)
}

async function updateUser(userData){
  const payload={
      apiName: 'LivisiblyAdminUserApi',
      path: 'users',
      options: {
        body: {
          user_data: userData,
        }
      }
    }

    const restOperation = put(payload);


    const response = await restOperation.response;
    return processResponse(response)
}


// Create users
export function useCreateUser() {
  return async (userData) => {
    try {
      const response = await createUser(userData);
      return handleApiResponse('USERS','userID', response, 'create');
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  };
}

// Update users
export function useUpdateUser() {
  return async (updatedData) => {
    try {
      const response = await updateUser(updatedData);
      return handleApiResponse('USERS','userID',response, 'update');
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  };
}

// Delete users
export function useDeleteUser() {
  return async (userData) => {
    try {
      const response = await deleteUser(userData);
      return handleApiResponse('USERS','userID',response, 'delete');
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  };
}